
export default {
  name: 'BaseRecaptcha',
  props: {
    id: {
      type: String,
      default: 'g-recaptcha',
    },
    error: {
      type: String,
      default: '',
    },
    mode: {
      type: String,
      default: 'visible',
      validator: (val) => ['visible', 'invisible'].includes(val),
    },
    options: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  head() {
    return {
      script: [
        {
          src: `https://www.google.com/recaptcha/api.js?onload=onloadRecaptcha${this.idF}&render=explicit`,
          async: true,
          defer: true,
          skip: !(this.$config.recaptcha.enabled),
          body: true,
        },
      ],
    };
  },
  data() {
    return {
      widgetId: 0,
      idF: Math.round(Math.random() * 1000),
    };
  },
  mounted() {
    window[`onloadRecaptcha${this.idF}`] = this.onLoad.bind(this);
  },
  methods: {
    getResponse() {
      return window.grecaptcha?.getResponse(this.widgetId);
    },
    execute() {
      window.grecaptcha?.execute(this.widgetId);
    },
    reset() {
      window.grecaptcha?.reset(this.widgetId);
    },
    onLoad() {
      if (!window.grecaptcha?.render) {
        return;
      }
      this.widgetId = window.grecaptcha.render(this.id, {
        sitekey: this.sitekey,
        size: this.size,
        // the callback executed when the user solve the recaptcha
        callback: (response) => {
          // emit an event called verify with the response as payload
          this.$emit('verify', response);
        },
        'expired-callback': (response) => {
          this.$emit('expired', response);
        },
        'error-callback': (response) => {
          this.$emit('error', response);
        },
        isolated: false,
        ...this.options,
      });
    },
  },
  computed: {
    isInvisible() {
      return this.mode === 'invisible';
    },
    sitekey() {
      if (this.isInvisible) {
        return this.$config.recaptchaInvisible.siteKey;
      }
      return this.$config.recaptcha.siteKey;
    },
    enabled() {
      if (this.isInvisible) {
        return this.$config.recaptchaInvisible.enabled;
      }
      return this.$config.recaptcha.enabled;
    },
    size() {
      if (this.isInvisible) {
        return this.$config.recaptchaInvisible.size;
      }
      return this.$config.recaptcha.size;
    },
  },
};
